export default {
  install(Vue, { store }) {
    const notify = {
      success: (msg) => store.dispatch('notify/showSuccess', msg),
      error: (msg) => store.dispatch('notify/showError', msg),
      warning: (msg) => store.dispatch('notify/showWarning', msg),
      info: (msg) => store.dispatch('notify/showInfo', msg),
      alert: (msg) => store.dispatch('notify/showAlert', msg),
      confirm: (msg) => store.dispatch('notify/showConfirm', msg),
    }
    Vue.prototype.$notify = notify
    Vue.notify = notify
  },
}
